module.exports = (
  $scope,
  $uibModal,
  $state,
  $stateParams,
  bulkuploadmappings,
  User) ->
  $scope.user = User

  $scope.loadPage = (page) ->
    $state.go('bulkuploadmappings', {
      'page': page
    }, { reload: true })

  $scope.bulkuploadmappings = bulkuploadmappings.results
  $scope.currentPage = $stateParams.page
  $scope.totalBulkUploadMappings = bulkuploadmappings.count
